export default __webpack_public_path__ + "static/media/shareVibe.8c4624fc.jpg";